import React from 'react';

export const MoreOptionsIcon: React.FC = () => (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
	>
		<circle cx="3" cy="8" r="1.5" fill="currentColor" />
		<circle cx="8" cy="8" r="1.5" fill="currentColor" />
		<circle cx="13" cy="8" r="1.5" fill="currentColor" />
	</svg>
);

export const PencilIcon: React.FC = () => (
	<svg
		width="17"
		height="17"
		viewBox="0 0 17 17"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14.9183 1.33195C14.4596 0.875214 13.8374 0.620728 13.1901 0.625054C12.5428 0.629492 11.9241 0.892379 11.4717 1.35529L1.805 11.022L0.625 15.6253L5.22833 14.4446L14.895 4.77795C15.358 4.32569 15.621 3.70706 15.6255 3.05982C15.6298 2.41258 15.3752 1.79045 14.9183 1.33195Z"
			stroke="currentColor"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M11.1953 1.63281L14.618 5.05548"
			stroke="currentColor"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M1.80566 11.0195L5.23166 14.4395"
			stroke="currentColor"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const TrashIcon: React.FC = () => (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
	>
		<path
			d="M1 3H15"
			stroke="currentColor"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9.5 1H6.5C5.94772 1 5.5 1.44772 5.5 2V3H10.5V2C10.5 1.44772 10.0523 1 9.5 1Z"
			stroke="currentColor"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M6.5 11.5V6.5"
			stroke="currentColor"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M9.5 11.5V6.5"
			stroke="currentColor"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.5767 14.0827C12.5337 14.6012 12.1003 15 11.58 15H4.42067C3.9004 15 3.46701 14.6012 3.424 14.0827L2.5 3H13.5L12.5767 14.0827Z"
			stroke="currentColor"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const ArrowLeftIcon: React.FC = () => (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
	>
		<path
			d="M15.5 8H0.5"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M7.5 1L0.5 8L7.5 15"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
